import { useState } from "react";
import styles from "./herosection.module.css";
import { Tent, Trees, Compass } from "lucide-react";
import AppointmentModal from "../../components/appointmentModal/AppointmentModal.js"
import heroImg from "../../assets/backgrounds/32378.jpg";

const HeroSection = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <section className={styles.heroSection_wrapper}>
        {/* Background Watermark/Decorative Icons */}
        <Trees className={styles.bgIconTrees} size={220} aria-hidden="true" />
        <Compass className={styles.bgIconCompass} size={150} aria-hidden="true" />
        <Tent className={styles.bgIconTent} size={120} aria-hidden="true" />

        <div className={styles.heroSection_inner}>

          {/* Left Content Section */}
          <div className={styles.heroSection_left}>
            <span className={styles.welcomeBadge}>Welcome to</span>
            <h1 className={styles.heroSection_heading}>
              Dima Niwas Campsite <br />
              <span className={styles.accentText}>Cum Restaurant</span>
            </h1>

            <p className={styles.heroSection_paragraph}>
              Discover the beauty of nature with Dima Niwas Campsite - your
              perfect escape from city life. From lush green forests to peaceful
              lakeside tents, we bring you closer to the wilderness with comfort
              and safety.
            </p>

            <button
              className={styles.heroSection_button}
              onClick={() => setIsModalOpen(true)}
            >
              <Tent className={styles.tentIcon} size={20} />
              <span>Book Your Camp Now</span>
            </button>
          </div>

          {/* Right Image Section */}
          <div className={styles.heroSection_right}>
            <div className={styles.imageContainer}>
              <div className={styles.imageBackdrop}></div>
              <img
                src={heroImg}
                alt="Dima Niwas Campsite"
                className={styles.heroImage}
              />
            </div>
          </div>

        </div>

        {/* Curved Divider at the bottom */}
        <div className={styles.curveDivider}>
          <svg viewBox="0 0 1440 120" preserveAspectRatio="none">
            <path
              d="M0,0 C480,80 960,80 1440,0 L1440,120 L0,120 Z"
              fill="#ffffff"
            />
          </svg>
        </div>
      </section>

      {/* Booking Modal */}
      <AppointmentModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
};

export default HeroSection;
